<template>
    <div 
    v-if="config && config.editor && editor && editor.type && (editor.type == type || editor.type == type.split('-')[1])"
    :class="[
        'editor',
        {'selected': selected()}, 
        {'editor-row': params && params.cols && params.hook},
        {'editor-porlet': type === 'porlet'},
        {'editor-input': type === 'data'},
        {'editor-add': type.split('-')[0] === 'add'}
    ]" 
    @click="openEditor()">
        <i :class="[type.split('-')[0] === 'add' ? 'el-icon-plus' : 'el-icon-edit']"></i>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
	export default {
		name: 'Editor',
        props: {
            ficha: {
                type: Object
            },
            params: {
                type: Object
            },
            type: {
                type: String
            }
        },
        computed: {
            ...mapState({
                config: state => state.config.data,
                editor: state => state.editor
            })
        },
        methods: {
            ...mapMutations([
                'setEditorForm',
                'setEditorBackup',
                'setEditorType'
            ]),
            async openEditor() {
                this.setEditorBackup(this.ficha)
                this.setEditorType(this.type)
                this.setEditorForm(this.params)
            },
            selected() {
                
                if (!this.params) return 

                let selected = false
                if(this.editor && this.editor.form) {
                    if (this.editor.type === 'data') {
                        selected = (this.editor.form.key === this.params.key)
                    }
                    else if (this.editor.type === 'row') {
                        selected = this.params.nombre === this.editor.form.nombre
                    }
                    else {
                        selected = (this.editor.form.id === this.params.id) && (this.editor.form.tipo === this.params.tipo) 
                    }
                }
                return selected
            }
        }
	}
</script>

<style lang="scss">
.editor {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background-color: $--color-header;
    font-size: 1rem;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    cursor: pointer;
    top: 0px;
    right: 0px;
    left: 0;
    bottom: 0;
    opacity: 0.5;
    margin: 2px;
    color: transparent;
    &:hover {
        color: white;
        //opacity: 0.8;
        width: auto!important;
        height: auto!important;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    &.editor-input {
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0px;
        width: auto;
        height: auto;
        background-color: rgba($--color-header, 0.27); // equivalente a #a98a5645
        &:hover {
            background-color: rgba($--color-header, 0.77); // equivalente a #a98a56c4
        }
    }

    &.selected {
        background-color: #ee7cffa3 !important;
        color: white;
        left: 0;
        bottom: 0;
        right:0;
        top:0;
        width: auto;
        height: auto;
    }

    &.editor-row {
        top: -10px;
        background-color: #E6A23C;
        left: 2px;
        right: 2px;
        width: auto;
        z-index: 0;
        opacity: 0.2;

        &:hover {
            //opacity: 0.4;
        }
    }

    &.editor-porlet {
        background-color: #67C23A;
        opacity: 0.4;
        left: 0;
        top: 0px;

        &:hover {
            //opacity: 0.8;
        }
    }

    &.editor-add {
        position: relative !important;
        border: 1px dashed #c3c3c3;
        background-color: #00000005;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: auto;
        height: 20px!important;
        margin: 5px 10px 15px 10px;
        color: #9a9a9a;
        opacity: 1;
        font-size: 0.6rem;
        &:hover {
            border: 1px dashed #808080;
            color: #4a4a4a;
        }
    }
}
</style>